import type { ReactNode } from 'react'
import cx from 'classnames'
import { Sandwich, SandwichBun, SandwichContent } from '@/components/Sandwich'
import { SplitView, SplitViewMain, SplitViewSide } from '@/components/SplitView'
import { useElementSize } from '@/hooks/element-hooks'
import styles from './JobCreation.module.css'

export interface JobCreationProps {
  outline: ReactNode
  header: ReactNode
  children?: ReactNode
  dialogs?: ReactNode
}

export function JobCreation({
  outline,
  header,
  children,
  dialogs,
}: JobCreationProps) {
  // The outline has no narrow layout, so it is hidden on small screens.
  const { size: rootSize, connectRef } = useElementSize()
  const shouldShowOutline = rootSize.width >= 900
  return (
    <div className={cx(styles.root)} ref={connectRef} data-test="draft-editor">
      <SplitView>
        {shouldShowOutline && <SplitViewSide>{outline}</SplitViewSide>}

        <SplitViewMain>
          <Sandwich stretch>
            <SandwichBun>{header}</SandwichBun>
            <SandwichContent>{children}</SandwichContent>
          </Sandwich>
        </SplitViewMain>
      </SplitView>
      {dialogs}
    </div>
  )
}
